import { memo, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

interface NavBarProps {
  title?: string;
  fixed?: boolean;
  onBack?: () => void;
  rightAction?: ReactNode;
  children?: ReactNode;
  glass?: boolean;
}

const NavBar = memo(function NavBar({
  title,
  fixed = false,
  onBack,
  rightAction,
  children,
  glass,
}: NavBarProps) {
  const navigate = useNavigate();

  const handleBack = onBack || (() => navigate(-1));

  const showGlass = glass ?? !!(title || children);

  return (
    <AppBar
      position={fixed ? "fixed" : "static"}
      sx={{
        ...(showGlass
          ? {
              background: "rgba(0,0,0,0.2)",
              backdropFilter: "blur(16px)",
            }
          : { background: "transparent" }),
        boxShadow: "none",
      }}
    >
      <Toolbar>
        <Typography variant="h6" component="h1" fontWeight="bold" sx={{ fontFamily: "inherit" }}>
          EssilorLuxottica
        </Typography>
      </Toolbar>
      {title ? (
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleBack}>
            <ChevronLeftIcon sx={{ fontSize: 32 }} />
          </IconButton>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{
              fontFamily: "inherit",
              flex: 1,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {title}
          </Typography>
          {rightAction || <Box sx={{ width: 40 }} />}
        </Toolbar>
      ) : null}
      {children}
    </AppBar>
  );
});

export default NavBar;
